<div class="sample-prompt-container" [formGroup]="promptForm">
    <epd-select
        #dropdownComponent
        placeholder="Sample Prompts"
        formControlName="prompt"
        [allowClear]="false"
        title="Start your search with the prompt"
    >
        <epd-option
            *ngFor="let samplePromptText of samplePromptTexts"
            [value]="samplePromptText"
            [label]="samplePromptText"
        ></epd-option>
    </epd-select>
</div>
